export default function drawer() {
  const buttonElement = document.querySelector('.js-drawer');

  if (buttonElement === null) return;

  const targetElements = document.querySelectorAll(buttonElement.dataset.hamburgerTarget);
  const dataHamburgerToggleClass = buttonElement.dataset.hamburgerToggleClass;
  const hamburgerToggleClass =
    typeof dataHamburgerToggleClass === 'undefined' ? '_open' : dataHamburgerToggleClass;

  if (targetElements.length === 0) return;

  targetElements.forEach((element) => {
    element.addEventListener('click', (event) => {
      const eventElement = event.target.closest('a[href]');
      const closeElement = event.target.closest('[data-hamburger-close]');

      if (
        !event.defaultPrevented &&
        (eventElement !== null || closeElement !== null) &&
        targetElements[0].classList.contains(hamburgerToggleClass)
      ) {
        buttonElement.click();
      }
    });
  });
  buttonElement.addEventListener('click', (event) => {
    event.preventDefault();
    targetElements.forEach((element) => {
      element.classList.toggle(hamburgerToggleClass);
    });
  });
}
